export function buildLogtoLoginUrl(returnTo: string, baseUrl: string) {
  const url = new URL('/auth/logto/login', baseUrl);
  url.searchParams.set('returnTo', returnTo);
  return url.toString();
}
